import { ScoopText, ScoopColumn } from '../../../../ui'
import styles from './WelcomeStep.module.scss'

const HIGHLIGHTS = [
    {
        title: 'Connect',
        text: 'Link your business tools in seconds — no code required',
    },
    {
        title: 'Explore',
        text: 'Ask questions in plain English and get AI-powered insights',
    },
    {
        title: 'Share',
        text: 'Create interactive dashboards and presentation-ready slides',
    },
]

export const WelcomeStep = ({ title, description }) => {
    return (
        <ScoopColumn className={styles.container}>
            <ScoopColumn className={styles.header}>
                <ScoopText className={styles.title}>{title}</ScoopText>
                <ScoopText className={styles.description}>{description}</ScoopText>
            </ScoopColumn>
            <ScoopColumn className={styles.highlights}>
                {HIGHLIGHTS.map((item, index) => (
                    <div key={index} className={styles.highlightCard}>
                        <ScoopText className={styles.highlightNumber}>{index + 1}</ScoopText>
                        <ScoopColumn className={styles.highlightContent}>
                            <ScoopText className={styles.highlightTitle}>{item.title}</ScoopText>
                            <ScoopText className={styles.highlightText}>{item.text}</ScoopText>
                        </ScoopColumn>
                    </div>
                ))}
            </ScoopColumn>
        </ScoopColumn>
    )
}
